import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { IFormConfig } from '../form.types';

@Component({
  selector: 'app-form-base',
  imports: [
    SmartusComponentsModule,
    FormlyModule,
    FormlyMaterialModule,
    FormlyMatDatepickerModule,
    ReactiveFormsModule,
  ],
  templateUrl: './form-base.component.html',
  styleUrls: ['./form-base.component.scss'],
})
export class FormBaseComponent {
  @Input() config: IFormConfig;
  @Input() form = new FormGroup({});
  @Output() formSubmitted = new EventEmitter<any>();
  private el: ElementRef;

  constructor(injector: Injector) {
    this.el = injector.get(ElementRef);
  }

  /**
   * Submits the form if its valid or scrolls to invalid control.
   */
  validateForm() {
    if (this.form.valid) {
      this.formSubmitted.emit(this.form.value);
    } else {
      this.scrollToFirstInvalidControl(true);
    }
  }

  /**
   * Searches for first invalid element and sets focus
   * @param repeatScroll Decide wheter to repeat scrolling
   */
  private scrollToFirstInvalidControl(repeatScroll: boolean) {
    this.form.markAllAsTouched();
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      '.mat-mdc-input-element.ng-invalid, .mat-mdc-select.ng-invalid, .mat-mdc-checkbox.ng-invalid, mat-mdc-form-field.ng-invalid'
    );

    try {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth' });
      firstInvalidControl.focus();
    } finally {
      if (repeatScroll) {
        setTimeout(() => {
          this.scrollToFirstInvalidControl(false);
        }, 10);
      }
    }
  }
}
